import { useShowCustomArticleLists } from "@tm/data/basket"
import { useMemo } from "react"

export function useAllCompilations() {
    const compilationsQuery = useMemo(() => ({}), [])
    const { data: { pages: compilationPages } = {} } = useShowCustomArticleLists(compilationsQuery)
    return useMemo(() => compilationPages?.flatMap((x) => x.data.customArticleLists) ?? [], [compilationPages])
}
